import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle, X } from 'lucide-react';

const DisclaimerModal = ({ show, onClose }) => (
  <AnimatePresence>
    {show && (
      <motion.div className="kb-disclaimer-overlay" onClick={onClose}
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        data-testid="kb-disclaimer-overlay">
        <motion.div className="kb-disclaimer-modal" onClick={(e) => e.stopPropagation()}
          initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }}
          data-testid="kb-disclaimer-modal">
          <div className="kb-disclaimer-header">
            <AlertTriangle size={18} />
            <h3>AI-Generated Content — Accuracy & Limitations</h3>
            <button className="kb-disclaimer-close" onClick={onClose} data-testid="kb-disclaimer-close">
              <X size={18} />
            </button>
          </div>
          <div className="kb-disclaimer-body">
            <p>In an attempt to be as helpful as possible, the IPMI Document Intelligence platform uses AI technology — including large language models (LLMs) and retrieval-augmented generation (RAG) — to answer questions and generate document summaries. Like all AI systems, it can occasionally produce responses that are incorrect, incomplete, or misleading. This is a known limitation of current AI technology.</p>
            <p>For example, the AI may misinterpret a document, present information out of context, or generate a response that sounds authoritative but is not fully accurate. Summaries and answers should always be treated as a starting point, not a final source of truth. We encourage you to click through to the original source documents to verify any information before acting on it.</p>
            <p>IPMI does not assume any responsibility for errors or omissions in AI-generated content. The Document Intelligence platform is provided as a member resource to help navigate and explore the archive — it is not a substitute for professional advice or official IPMI communications.</p>
            <p className="kb-disclaimer-contact">If you notice an inaccurate or misleading response, please use the suggestion box inside the app or contact us at <a href="mailto:mail@ipmi.org">mail@ipmi.org</a>.</p>
          </div>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);

export default DisclaimerModal;
